import { BadgeCheck, FileSpreadsheet, Network, Scale, MapPin, Lock } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

// REVIEW: sample credential copy — replace with verified licenses/certifications before launch.
const ITEMS = [
  { icon: BadgeCheck, title: "Property Claims Experience", desc: "Hands-on background across residential, HOA, and commercial property losses." },
  { icon: FileSpreadsheet, title: "Industry-Standard Estimating", desc: "Estimates and scopes prepared in carrier-recognized formats and line-item detail." },
  { icon: Scale, title: "Litigation Support Ready", desc: "Documentation structured for attorneys, mediation, appraisal, and dispute review." },
  { icon: Network, title: "Expert Coordination", desc: "Engineers, contractors, and specialists aligned under one documented process." },
  { icon: MapPin, title: "Florida & Georgia Focus", desc: "Regional knowledge of storm exposure, building conditions, and claim climates." },
  { icon: Lock, title: "Confidential Engagements", desc: "Client files handled with discretion, secure storage, and controlled access." },
];

export const Credentials = () => (
  <section id="credentials" className="relative py-20 sm:py-24 md:py-32 btr-bg-charcoal overflow-hidden" data-testid="credentials-section">
    <div className="absolute inset-0 btr-grid opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6">
      <SectionHead
        badge="Credentials"
        title={<>Qualified to stand behind <span className="text-[#a2020b]">every report</span>.</>}
        lede="Experience, method, and discipline that hold up when a claim, board decision, or legal dispute is on the line."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-12">
        {ITEMS.map((c, i) => {
          const Icon = c.icon;
          return (
            <div key={c.title} className="btr-reveal btr-glass rounded-lg p-6 hover:border-[#a2020b]/45 transition-colors" style={{ transitionDelay: `${i * 50}ms` }} data-testid={`credential-${i}`}>
              <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
              <div className="font-display font-bold text-white text-base mt-4">{c.title}</div>
              <div className="font-body text-zinc-400 text-sm mt-2 leading-relaxed">{c.desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
